import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import orgChartLogo from "../assets/image/orgchartLogo.png";
import nineBoxLogo from "../assets/image/9boxlogo.png";
import axios from "axios";
import {
  NINEBOX_API_URL,
  NINEBOX_BASE_URL,
  ORGCHART_API_URL,
  ORGCHART_BASE_URL,
} from "../config/host";
import ConfirmationPopup from "../components/popup/ConfirmationPopup";
import { useSelector } from "react-redux";
import toastr from "toastr";
import { postData } from "../services/api";

const SsoLoginContext = createContext();

export const SsoLoginProvider = ({ children }) => {
  const userData = useSelector((state) => state.auth?.user);
  const [enabledConfirmationPopup, setEnabledConfirmationPopup] =
    useState(false);
  const [actionValue, setActionValue] = useState({});
  const [selectedWebsite, setSelectedWebsite] = useState({});
  const [syncingLoader, setSyncingLoader] = useState(false);
  const [message, setMessage] = useState(null);
  const dropdownData = [
    // {
    //   _id: 1,
    //   name: "ORG Chart",
    //   image: orgChartLogo,
    //   code: "orgChart",
    //   value: "orgChart",
    //   color: "orange-500",
    // },
    {
      _id: 2,
      name: "9BoxNow",
      image: nineBoxLogo,
      code: "9BoxNow",
      value: "9BoxNow",
      color: "blue-500",
    },
  ];

  const companyCreateVerify = useCallback(
    async (url, headersToken, selectedsite) => {
      const data = { code: "successionNow" };
      try {
        const result = await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${headersToken}`,
            "Content-Type": "application/json",
          },
        });
        if (result?.data?.status === 200) {
          setSyncingLoader(false);
          toastr.success("Comapny syncing successfull");
          window.open(
            result?.data?.data?.redirectUrl,
            "_blank",
            "noopener,noreferrer"
          );
          setEnabledConfirmationPopup(false);
        } else if (result?.data?.status === 417) {
          setSyncingLoader(false);
          window.open(
            result?.data?.data?.redirectUrl,
            "_blank",
            "noopener,noreferrer"
          );
        } else {
          setSyncingLoader(false);
          toastr.error(
            result?.data?.message ||
              "An error occurred while processing the request."
          );
          setEnabledConfirmationPopup(false);
        }
      } catch (err) {
        setSyncingLoader(false);
        toastr.error(
          err?.response?.data?.message ||
            "An error occurred while processing the request."
        );
        setEnabledConfirmationPopup(false);
      }
    },
    []
  );

  const getGenarateToken = async (DOMAIN, API_URL = "") => {
    setSyncingLoader(true);
    try {
      const res = await postData("create/token", {
        domain: DOMAIN,
      });
      if (res?.status === 200) {
        const url = API_URL + "verify/token";
        const headersToken = res?.data;
        companyCreateVerify(url, headersToken, selectedWebsite);
      } else {
        toastr.error(res?.data?.message || "Something went wrong");
        setEnabledConfirmationPopup(false);
        setSyncingLoader(false);
      }
    } catch (err) {
      setSyncingLoader(false);
      toastr.error(err?.message || "Somthing went wrong !!!");
      setEnabledConfirmationPopup(false);
    }
  };

  useEffect(() => {
    setMessage(
      `Hello ${userData?.name}, do you want to log in to the ${selectedWebsite?.name} website? If yes, please click the Confirm button to proceed.`
    );
  }, [selectedWebsite, userData]);

  useEffect(() => {
    if (actionValue && actionValue.button_type === "confirm") {
      if (selectedWebsite?.code === "9BoxNow") {
        getGenarateToken(NINEBOX_BASE_URL, NINEBOX_API_URL);
      } else if (selectedWebsite?.code === "orgChart") {
        getGenarateToken(ORGCHART_BASE_URL, ORGCHART_API_URL);
      } else {
        toastr.error("Please Select a Website For Login");
      }
    }
  }, [actionValue]);

  return (
    <SsoLoginContext.Provider
      value={{
        enabledConfirmationPopup,
        setEnabledConfirmationPopup,
        dropdownData,
        selectedWebsite,
        setSelectedWebsite,
      }}
    >
      {children}
      {selectedWebsite && enabledConfirmationPopup && (
        <ConfirmationPopup
          isOpen={enabledConfirmationPopup}
          title={"Confirmation"}
          message={message}
          confirmButtonLabel={"Confirm"}
          cancelButtonLabel={"Cancel"}
          setIsOpen={(val) => setEnabledConfirmationPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
          setLoading={setSyncingLoader}
          loading={syncingLoader}
        />
      )}
    </SsoLoginContext.Provider>
  );
};

export const useSsoLogin = () => {
  return useContext(SsoLoginContext);
};
